import React, { useState } from "react";
import AdminFareEditor from "./Components/fare/AdminFareEditor";
import Service from "./Components/Pages/Service/Service";
import Staff from "./Components/Pages/Staff/Staff";
import Offer from "./Components/Pages/Offers/Offer";
import StatsDashboard from "./Components/Pages/Income/StatsDashboard";
import AdminRides from "./Components/Pages/Rides/ridesList";
import DriversTable from "./Components/Pages/DriversTable";
import Sidebar from "./Components/Sidebar/Sidebar";
import Sidebar2 from "./sidebar2";

function Sidebarapp2() {
  const [activeTab, setActiveTab] = useState("city");
  const [driver, setDriver] = useState(null);

  const renderContent = () => {
    switch (activeTab) {
       case "fares":
        return <AdminFareEditor />;
      // case "city":
      //   return <City />;
      // case "location":
      //   return <Location />;
      case "services":
        return <Service />;
      case "staff":
        return <Staff />;
      case "offers":
        return <Offer />;
      case "income":
        return <StatsDashboard />;
      case "rides":
        return <AdminRides />;
        case "driver":
          return <DriversTable  onOpenDocs={(d) => setDriver(d)}/>;
      default:
        return <Service />;
    }
  };

  return (
    <div className="flex h-screen">
      <Sidebar2 setActiveTab={setActiveTab} activeTab={activeTab} />
      <div className="flex-1 bg-white p-6 overflow-auto">{renderContent()}</div>
     
    </div>
  );
}

export default Sidebarapp2;
